// Minimal renderer for the small subset of markdown the synthesis emits: `## ` headings,
// blank-line-separated paragraphs and `**bold**`. A full markdown dependency is not worth
// it for three constructs, and audits predating the sectioned prompt hold a plain
// paragraph — which falls through here as a single <p>, exactly as before.

function renderInline(text) {
  // Odd indices of the split are the captured bold runs.
  return text.split(/\*\*(.+?)\*\*/g).map((part, i) =>
    i % 2 === 1 ? <strong key={i} className="font-semibold">{part}</strong> : part
  )
}

export default function RichText({ text, className = '', size = 'text-sm' }) {
  const blocks = (text || '').split(/\n{2,}/).map(b => b.trim()).filter(Boolean)
  if (blocks.length === 0) return null

  return (
    <div className={className}>
      {blocks.map((block, i) =>
        block.startsWith('## ') ? (
          <h4
            key={i}
            className="text-[0.7rem] font-bold text-[#77726e] uppercase tracking-wide mt-5 mb-1.5 first:mt-0"
          >
            {block.slice(3).trim()}
          </h4>
        ) : (
          <p key={i} className={`${size} text-[#2f3126] leading-relaxed whitespace-pre-line mt-2 first:mt-0`}>
            {renderInline(block)}
          </p>
        )
      )}
    </div>
  )
}
